import React from 'react';
import ResourceCard from '/src/Components/ResourceCard/ResourceCard';
import './style.css';

const ProjectResources = ({ project, resources }) => {

    const SECTION_HEADER = "Helpful Resources";
    const fullIntroText = "Below is a selection of resources to help you with this project. To see even more, check out our Resource Hub!";

    return (
        <div className="project-card-section-container">
            <div className="project-card-section-header-frame">
                <h2 className="project-card-section-header box-shadow-standard">{SECTION_HEADER}</h2>

                <p className="project-card-section-intro-sentence text-align-center">{fullIntroText}</p>
            </div>
            <div className="project-card-resources-container">
                {resources.map((resource, index) => (
                    <ResourceCard key={index} resource={resource} />
                ))}
            </div>
        </div>
    );
};

            export default ProjectResources;